import { apiClient } from '@/api/client'
import type { BulkOverrideResult, FleetOverview, FleetSeverity } from './types'

const BASE = '/portal/settings/alarms/subscriptions/fleet'

export async function fetchFleetOverview(): Promise<FleetOverview> {
  const { data } = await apiClient.get<FleetOverview>(`${BASE}/summary`)
  return data
}

export async function applyFleetSeverityDefault(severityId: number, isSubscribed: boolean): Promise<FleetSeverity> {
  const { data } = await apiClient.post<FleetSeverity>(`${BASE}/severity/${severityId}`, {
    is_subscribed: isSubscribed,
  })
  return data
}

export async function applyFleetBulkOverride(
  controllerIds: string[],
  overrides: Record<number, boolean>,
): Promise<BulkOverrideResult> {
  const { data } = await apiClient.post<BulkOverrideResult>(`${BASE}/bulk`, {
    controller_ids: controllerIds,
    overrides,
  })
  return data
}
